export interface IAdpCertificateFileShareSiteLinks {
    
    manifestLink: string;
    pdfLink: string;
    
}